// Api.js
import {
  signOut as firebaseSignOut,
  onAuthStateChanged,
  updateProfile,
  signInWithCustomToken,
} from "firebase/auth";
import { callFunction } from "./callFunction";
import {
  collection,
  addDoc,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  getDocs,
} from "firebase/firestore";
import { auth, db } from "../firebase";

class Api {
  // Authentication methods
  static async sendOTP(phoneNumber) {
    try {
      return await callFunction("sendOTP", { phoneNumber });
    } catch (error) {
      throw error;
    }
  }

  static async verifyOTP(phoneNumber, otp) {
    try {
      const result = await callFunction("verifyOTP", { phoneNumber, otp });
      if (result.success && result.customToken) {
        const userCredential = await signInWithCustomToken(
          auth,
          result.customToken
        );
        return userCredential.user;
      } else {
        throw new Error(result.message || "OTP verification failed");
      }
    } catch (error) {
      throw error;
    }
  }
  static async updateFBUserProfile(user, data) {
    try {
      const didUpdate = await updateProfile(user, data);
      return didUpdate;
    } catch (error) {
      throw error;
    }
  }
  static async signOut() {
    try {
      localStorage.removeItem("vendor");
      localStorage.removeItem("user");
      localStorage.removeItem("vendorID");
      await firebaseSignOut(auth);
    } catch (error) {
      throw error;
    }
  }

  static onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  }

  // Firestore methods
  static async addDocument(collectionName, document) {
    try {
      const docRef = await addDoc(collection(db, collectionName), document);
      return docRef.id;
    } catch (error) {
      throw error;
    }
  }

  static async getDocument(collectionName, docId, nestedCollectionName = null) {
    try {
      const docRef = doc(db, collectionName, docId);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        throw new Error("Document not found");
      }

      const docData = docSnap.data();

      if (!nestedCollectionName) {
        return docData;
      }

      const nestedCollectionRef = collection(docRef, nestedCollectionName);
      const nestedCollectionSnap = await getDocs(nestedCollectionRef);

      const nestedCollectionData = nestedCollectionSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return {
        ...docData,
        [nestedCollectionName]: nestedCollectionData,
      };
    } catch (error) {
      throw error;
    }
  }

  static async updateDocument(collectionName, docId, data) {
    try {
      const docRef = doc(db, collectionName, docId);
      await updateDoc(docRef, data);
    } catch (error) {
      throw error;
    }
  }

  static async deleteDocument(collectionName, docId) {
    try {
      const docRef = doc(db, collectionName, docId);
      await deleteDoc(docRef);
    } catch (error) {
      throw error;
    }
  }

  static async getCollection(collectionName) {
    try {
      const querySnapshot = await getDocs(collection(db, collectionName));
      const docs = [];
      querySnapshot.forEach((doc) => docs.push({ ...doc.data(), id: doc.id }));
      return docs;
    } catch (error) {
      throw error;
    }
  }

}

export default Api;
